export const chartStyles = `
.opt-chart {
    background: var(--surface);
    border-radius: var(--radius-md);
    padding: var(--spacing-md);
    box-shadow: var(--shadows-sm);
    height: 100%;
}

.opt-chart-header {
    margin-bottom: var(--spacing-md);
}

.opt-chart-title {
    font-size: var(--typography-fontSize-lg);
    font-weight: var(--typography-fontWeight-semibold);
    color: var(--text-primary);
}

.opt-chart-content {
    position: relative;
    height: 300px;
}

.opt-chart.span-2 {
    grid-column: span 2;
}
`;